// Système de logging conditionnel pour éviter l'exposition d'informations sensibles
const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  error: (...args) => {
    if (isDevelopment) {
      console.error(...args);
    }
  },
  
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  
  // Pour les logs qui doivent toujours apparaître (erreurs critiques)
  always: (...args) => {
    console.log(...args);
  }
};

export default logger;
